export const TIME_UNIT_MODEL = "time-unit";

const timeUnitModel = {
  name: ""
};

export default timeUnitModel;
